const LOCAL_STORAGE_CONSTANTS = {
  IsPassExpired: "isPassExpired",
  RefreshToken: "refreshToken",
  Token: "token",
  TokenExpirationTime: "expirationTime",
};

export default LOCAL_STORAGE_CONSTANTS;
